import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { httpinstance } from "../../axios/api"

export const getairbookinghistory = createAsyncThunk('getairbookinghistory', async (newpage)=>{
    try{
        const url = `bookinghistory_for_air?page=${newpage}`
        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})


export const getairbookinghistorysearch = createAsyncThunk('getairbookinghistorysearch', async (queryId)=>{
    console.log(queryId);
    try{
        const url = `bookinghistory_for_air/${queryId}`
        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})
export const getoceanbookinghistory = createAsyncThunk('getoceanbookinghistory', async (query)=>{
    try{
        const url = 'bookinghistory_for_ocean'
        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})

export const getcancelhistory = createAsyncThunk('getdeletebooking', async ()=>{
    try{
        const url = 'getdeletebooking'
        const response = await httpinstance.get(url)
        console.log(response);
        return response
    }catch (err){
        return err.response
    }
})
export const getcancelhistorysearch = createAsyncThunk('getdeletebookingsearch', async (queryId)=>{
    try{
        const url = `getdeletebooking${queryId}`
            //   const url = `getdeletebooking?search=${encodeURIComponent(query)}`; // ✅ query param
    //   const url = `getdeletebooking?search=${encodeURIComponent(queryId)}`; // ✅ correct

        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})
export const getsinglebookingdata = createAsyncThunk('getsinglebookingdata', async (values)=>{
    try{
        const url = 'single_booking_data'
        const response = await httpinstance.post(url,values)
        return response
    }catch (err){
        return err.response
    }
})
export const getsinglecancelbookingdata = createAsyncThunk('getsinglecancelbookingdata', async (values)=>{
    try{
        const url = 'getdeletebyid'
        const response = await httpinstance.post(url,values)
        return response
    }catch (err){
        return err.response
    }
})
const initialState = {
    bookinghistorydata : {},
    bookingDetailPageData : {},
}

const bookingHistorySlice = createSlice({
    name : 'bookinghistoryslice',
    initialState,
    extraReducers:{

    }
})

export const getsavedbookingdata = state => state.bookinghistory.bookingDetailPageData;
export default bookingHistorySlice.reducer